import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { getPgidByPath } from './routeConfig';

/**
 * 路由上报 Hook
 * 监听路由变化，自动获取当前页面的 pgid
 */
export function useRouteReport(): string {
  const location = useLocation();

  const pgid = useMemo(() => {
    // home 路径不上报，返回空字符串
    if (location.pathname === '/') {
      return '';
    }
    const result = getPgidByPath(location.pathname);
    // 为getPgidByPath的返回值做空值/无效值检验
    return result === '' ? '' : result;
  }, [location.pathname]);

  return pgid;
}
